import React, {useState} from 'react';
import './InputFormsForQuestions.scss';
import { closeInputForms, idQuestionsCreate, validateQuizImageSize, validateQuizImageType, uploadQuizImg } from '../../../adminSlice';
import { validateFileTypeNote, validateFileSizeNote } from '../../../../../helper/validation';

const AddInputFormsForQuestions  = (props) => {

    
    const [userInputContent, setUserInputContent] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [validate, setValidate] = useState(false); 
    const [checkImg, setCheckImg] = useState(false);
    const [typeQuest, setTypeQuest] = useState(1);

    const { dispatch } = props;
 
     // SET AFF NOTE FILES
    const selectFiles = (e) => {
        
        setSelectedFiles(e.target.files);
        console.log(e.target.files[0]);

            //validate type image
            const addFile = document.getElementById('add-quiz-img');
            console.log(addFile);
            let valideTypeMessage = validateFileTypeNote(addFile);
            
           dispatch(validateQuizImageType(valideTypeMessage));
            //validate size image
            let valideSizeMessage = validateFileSizeNote(addFile);
           // console.log(valideTypeMessage);
            console.log(valideSizeMessage);
           // console.log(e.target.files);
           dispatch(validateQuizImageSize(valideSizeMessage));
        console.log(e.target.files.length);

       if ((valideTypeMessage === true) && (valideSizeMessage === true) && (e.target.files.length !== 0)) {
        setValidate(true);
        
       } else {
        setValidate(false);
       }


    }    
       //HANDLE UPLOAD -ADD PART NOTE
    const handleUploadAddQuizImg = e => {
       console.log('WTF');
           
           e.preventDefault();
    
            //const valideTypeMessage = false;
            //const valideSizeMessage = false;
           const valideTypeMessage = props.adminState.errorQuizImageValidateType;
           const valideSizeMessage = props.adminState.errorQuizImageValidateSize;
    
       
       if (!valideTypeMessage && !valideSizeMessage) {
          console.log('START UPLOAD QUIZ IMG AFTER GOOD VALIDATION');
          // console.log(props.selectedIdNote, notePartTitle,notePart,noteText,noteImgText, selectedFiles );
           let formData = new FormData();

           console.log("quiz_id" + props.adminState.selectedQuize);
           console.log("question_content" + userInputContent);
           console.log(selectedFiles[0]);

           formData.append("quiz_id",props.adminState.selectedQuize);
           
           formData.append("question_content",userInputContent);
           formData.append("sort_quest",typeQuest);
           formData.append("file", selectedFiles[0]);
           
           console.log(formData);
          dispatch(idQuestionsCreate(formData));
    
       
          //clear input forms
           clearInputForms();
           clearInputFile();
    
       
       } else return null;
       
         
         }

    //CLEAR INPUT FILE NAME
    const clearInputFile = () => {
    document.getElementById('add-quiz-img').value = '';
    }
    // CLEAR INPUT FORMS
    const clearInputForms = () => {
        
        setSelectedFiles([]);
    } 


// ENTER INPUT
const handleUserInputContent = (e) => {

    setUserInputContent(e.target.value);

}




// CLOSE FORM
const onClose = () => {

    dispatch(closeInputForms());

}
// HANDLE CHECK IMG EDIT

const handleEditImageNotePart = () => {
 setCheckImg(!checkImg);
 clearInputFile();

}
// CHOOSE TYPE QUESTION
// CLOSE FORM
const handleTypeQuest = (e) => {

   console.log('type question');
   console.log(typeof(e.target.options[e.target.selectedIndex].value));
    setTypeQuest(Number(e.target.options[e.target.selectedIndex].value));

}




 
        //console.log(this.props.adminState.openInputForms);
     if (props.adminState.openAddInputFormsForQuestions) {
        return(
      <div className="InputFormsForQuestions">
                           
        <div className='container-row'>  
            <div className='container-column'> 
                <p>Создать новый вопрос:</p>
                <form>
                
                    <label>
                        Введите вопрос: </label>
                    <textarea  onChange={handleUserInputContent} 
                    ></textarea>
                        <label for="typequest">Тип вопроса</label>
                        <select name="typequest"  onChange={handleTypeQuest}>
                            <option value="" selected disabled hidden>Выбрать тип вопроса</option>
                                <option value="1">1 тип</option>
                                <option value="2">2 тип</option>
                                <option value="3">3 тип</option>
                                <option value="4">4 тип</option>

                                
                        </select>
                        


                </form>
                
                <form>
                    
                    <fieldset>
                        <legend>Добавить изображение</legend>

                        <div>
                            <input className='check-box' type="checkbox"  name="img" value={checkImg} onChange={handleEditImageNotePart}  checked={checkImg}/>
                                <label htmlFor="img"></label>
                        </div> 
                    </fieldset>
        
                    <input  id='add-quiz-img' className="input-selected" type="file" accept="image/*" onChange={selectFiles}  disabled={!checkImg}/>
                </form>
                <p className='p-text'>Допустимые форматы -jpg, jpeg, gif, png, webp. Допустимый размер файла до 0.5Мб</p>
                {props.adminState.errorQuizImageValidateSize ? <p className='err-text'>{props.adminState.errorQuizImageValidateSize}</p> : null}
                {props.adminState.errorQuizImageValidateType ? <p className='err-text'>{props.adminState.errorQuizImageValidateType}</p> : null}
                <button className='upload' onClick={handleUploadAddQuizImg } disabled={ ((validate && checkImg) || (!checkImg)) ? false : true}>Добавить</button>
                
                <button onClick={onClose}>Закрыть</button>
             </div>
             
        </div>
    </div>
        )
     } else return null;
       
     

        
    
}
export default AddInputFormsForQuestions;